import HelpersController from './HelpersController';

import WithType from './../WithType';

let _this = {};

/**
 *
 */
class HelpersHeap extends HelpersController {

    /**
     *
     * @param props
     * @param main
     */
    constructor(props, main) {
        super(props);
        this.props = props;
        this.main = main;

        this.arr = [];
        const {current_name} = this.props;
        _this = this;
    };

    size = () => {
        return this.arr.length;
    }

    push = (item) => {
        this.arr.push(item);
        this.up(this.arr.length - 1);
    }

    pop = () => {
        if (!this.arr.length) return null;

        const
            top = this.arr[0],
            last = this.arr.pop();

        if (this.arr.length) {
            this.arr[0] = last;
            this.down(0);
        }
        return top;
    }

    less = (i, j) => {
        return this.arr[i].f < this.arr[j].f;
    }

    swap = (i, j) => {
        [this.arr[i], this.arr[j]] = [this.arr[j], this.arr[i]];
    }

    up = (i) => {
        while (i > 0) {
            const p = (i - 1) >> 1;
            if (!this.less(i, p)) break;

            this.swap(i, p); i = p;
        }
    }

    down = (i) => {
        const n = this.arr.length;
        for (;;) {
            let
                s = i,
                l = (i << 1) + 1,
                r = l + 1;

            if (l < n && this.less(l, s)) {
                s = l
            };

            if (r < n && this.less(r, s)) {
                s = r;
            }

            if (s === i) {
                break;
            }

            this.swap(i, s);
            i = s;
        }
    }
};

/**
 *
 * @type {{}}
 */
HelpersHeap.propTypes = {};

/**
 *
 * @type {{}}
 */
HelpersHeap.defaultProps = {};

/**
 *
 * @param ClassObject
 * @param className {className: 'className'}
 * @returns {function(*): function({}=): *} pass _this ClassMain (required) and props {} (optional)
 */
export default WithType(HelpersHeap, {className: 'HelpersHeap'});